module.exports = __webpack_public_path__ + "30d6a4f7ef1817416e18bb6a40dfd844.png";